var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accessLevel)?_c('Icon',{staticClass:"w-4 h-4",class:_vm.accessLevelColour,attrs:{"icon":_vm.accessLevelIcon}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }